import { useDispatch, useSelector } from "react-redux"
import { Box,Stack, Select ,MenuItem,Typography,Grid,Divider,Button,InputBase,RadioGroup, FormControlLabel, Radio, FormLabel, Chip } from "@mui/material";

import { useEffect, useMemo, useState, useRef } from "react";
import { updateKioskProduct, updateSelectedCapacity } from "../Redux/products";
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ProductCard from "./productCard";
import CustomAxios from '../utils/CustomAxios';
import { Inventory } from "./product_management/inventory";
import { updateUserCart } from "../Redux/user";
import { updateorderRefresh } from "../Redux/orders";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import {Search, ShoppingCart, Close, Menu } from '@mui/icons-material';
import { useFetchOrders, useGetCategories, useGetSubCategories } from "./globalFunctions";
import { useNavigate } from "react-router-dom";


import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';

const EMPTY_CART_RESPONSE = { cart: { products: [] }, product_details: [] };

const KioskOrderManagement=()=>{
    const products = useSelector(state => state.products.products);
    const kiosk_products=useSelector(state=>state.products.kioskProducts)
    const categories = useSelector(state => state.category.category)
    const subcategories = useSelector(state => state.subcategory.subcategory)
    let userCart=useSelector(state=>state.user.userCart)
    const selectedHub = useSelector(state => state.user.selected_hub);
    const user=useSelector(state=>state.user.id)
    const user_role = localStorage.getItem('role');
    const [cartResponse,setCartResponse]=useState(EMPTY_CART_RESPONSE) 
    const [total,setTotal]=useState(0)
    const [amount,setAmount]=useState(0) 
    const [paymentMode, setPaymentMode] = useState("online");
    const [tax,setTax]=useState(0)
  const [orderlist,setOrderList]=useState([])
  const [cartOpen, setCartOpen] = useState(false)
  const [subcategorySidebarOpen, setSubcategorySidebarOpen] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [productsType, setProductsType] = useState('walkin');
  const [selectedOrderType, setSelectedOrderType] = useState('walkin'); // 'walkin' or 'online'
  const [orderTypeError, setOrderTypeError] = useState('');
  const getCategories = useGetCategories();
  const getSubCategories = useGetSubCategories();

  const handleChange = (event, newValue) => {
    dispatch(updateKioskProduct([]))
    setProductsType(newValue);
    setFilters({ ...Filters, subCategoryName: "" });
    setSubcategorySidebarOpen(false); // Close sidebar when switching tabs
  };
  // Reset tab on mount to avoid stale state when navigating back
  useEffect(() => {
    setProductsType('walkin');
  }, []);
    const [Filters,setFilters] = useState({
        search:"",
        categoryId:"",
        subCategoryName:"",
      })
      const [filtered,setFiltered]=useState([]) 

      const resolvedHubId = useMemo(() => {
        const normalizeValue = (value) => {
          if (value === null || value === undefined) return null;
          if (Array.isArray(value)) {
            if (value.length === 0) return null;
            return normalizeValue(value[0]);
          }
          if (typeof value === 'string') {
            if (value.trim() === '' || value === 'null') return null;
            const parsed = Number(value);
            return Number.isNaN(parsed) ? value : parsed;
          }
          return value;
        };

        const direct = normalizeValue(selectedHub);
        if (direct !== null && direct !== undefined) return direct;

        const storedSelectedHub = localStorage.getItem('selected_hub');
        if (storedSelectedHub) {
          try {
            const parsed = JSON.parse(storedSelectedHub);
            const normalized = normalizeValue(parsed);
            if (normalized !== null && normalized !== undefined) return normalized;
          } catch (error) {
            const normalized = normalizeValue(storedSelectedHub);
            if (normalized !== null && normalized !== undefined) return normalized;
          }
        }

        const storedHubs = localStorage.getItem('hub');
        if (storedHubs) {
          try {
            const parsed = JSON.parse(storedHubs);
            const normalized = normalizeValue(parsed);
            if (normalized !== null && normalized !== undefined) return normalized;
          } catch (error) {
            const normalized = normalizeValue(storedHubs);
            if (normalized !== null && normalized !== undefined) return normalized;
          }
        }

        return null;
      }, [selectedHub]);

      useEffect(()=>{
        let list = kiosk_products || [];
        if (Filters.search.trim()){
            const q = Filters.search.toLowerCase();
            list = list.filter(item => (item.item_name || "").toLowerCase().includes(q))
        }
        if (Filters.categoryId){
            list = list.filter(item => {
              const cid = item.category_id ?? item.category?.id ?? item.category ?? item.categoryId;
              return String(cid) === String(Filters.categoryId);
            })
        }
        if (Filters.subCategoryName){
            list = list.filter(item => {
              const itemSubCategory = (item.item_sub_category || item.subcategory_name || item.sub_category_name || item.subCategoryName || "").toLowerCase();
              return itemSubCategory === Filters.subCategoryName.toLowerCase();
            })
        }
        setFiltered(list);
      },[Filters,kiosk_products])

      useEffect(()=>{
        getCategories && getCategories();
        getSubCategories && getSubCategories();
      },[])

      const walkinSubcategoriesList = useMemo(() => {
        const map = new Map();

        const addSubcategory = (id, name) => {
          const normalizedName = (name || '').trim();
          if (!normalizedName && !id) return;
          // Skip "all" subcategory since we have a hardcoded "All" button
          if (normalizedName.toLowerCase() === 'all') return;
          const key = normalizedName
              ? normalizedName.toLowerCase()
              : String(id).toLowerCase();
          if (map.has(key)) return;
          map.set(key, {
              id: id || key,
              subcategory_name: normalizedName || `Subcategory ${map.size + 1}`
          });
      };

        const walkinCategory = (categories || []).find(cat => {
            const catName = (cat.category_name || '').toLowerCase();
            return catName === 'walkin' || catName === 'walk-in' || catName.includes('walkin');
        });

        const walkinCategoryId = walkinCategory ? String(walkinCategory.id) : null;

        if (walkinCategoryId && subcategories && subcategories.length > 0) {
            subcategories.forEach(subcat => {
                const subcatCategoryId = String(subcat.category_id || '');
                if (subcatCategoryId === walkinCategoryId) {
                    addSubcategory(subcat.id, subcat.subcategory_name || subcat.name);
                }
            });
        }

        (kiosk_products || []).forEach(product => {
            const sid = product.subcategory_id 
                ?? product.sub_category_id 
                ?? product.subcategory?.id 
                ?? product.subCategoryId 
                ?? product.item_sub_category;
            const label = product.subcategory_name 
                ?? product.sub_category_name 
                ?? product.item_sub_category 
                ?? product.subCategoryName 
                ?? product.subcategory?.name;

            if (sid || label) {
                addSubcategory(sid || label, label);
            }
        });

        return Array.from(map.values());
      }, [categories, subcategories, kiosk_products]);
    
 const lastSyncedCart = useRef(null);

 const createCart=async()=>{
    if (!resolvedHubId) {
        console.warn("No hub resolved while creating cart");
        return;
    }
    const hasItems = (userCart || []).some(product =>
        (product.capacity || []).some(cap => Number(cap.item_quantity) > 0)
    );
    if (!hasItems) {
        return;
    }
    // Prevent duplicate syncs for same payload
    const payload = {
        products: userCart,
        inventory_id: resolvedHubId,
        user: user
    };
    const payloadKey = JSON.stringify(payload);
    if (lastSyncedCart.current === payloadKey) {
        return;
    }
    lastSyncedCart.current = payloadKey;

    try {
        const res = await CustomAxios.post("kiosk_order_creation/", payload);
        setCartResponse(res.data);
        setCartOpen(true); // Auto-open cart when items are added
        // merge back order_origin from local cart so we don't lose it
        const localById = (userCart || []).reduce((acc, p) => { acc[p.product_id] = p; return acc; }, {});
        const mergedProducts = (res.data.cart?.products || []).map(p => {
          const origin = localById[p.product_id]?.order_origin;
          return origin ? { ...p, order_origin: origin } : p;
        });
        dispatch(updateUserCart(mergedProducts))
    } catch (err) {
        console.error(err);
        lastSyncedCart.current = null;
    }
 }
 useEffect(()=>{
    let totalPrice=0
    let subTotal=0
    let totalTax=0 
    userCart.map(product=>{
        return product.capacity.map(cap=>{
            if (cap.item_quantity>0&&cap.item_quantity!="") {
                totalPrice+=parseFloat((parseFloat(cap.item_offers_price!=0?(parseFloat(cap.item_quantity)*parseFloat(cap.item_offers_price)).toFixed(2):(parseFloat(cap?.item_quantity)*parseFloat(cap.item_selling_price)).toFixed(2))*(cap.item_tax/100))+parseFloat(cap.item_offers_price!=0?(parseFloat(cap.item_quantity)*parseFloat(cap.item_offers_price)).toFixed(2):(parseFloat(cap?.item_quantity)*parseFloat(cap.item_selling_price)).toFixed(2)))
                subTotal+=parseFloat(cap.item_offers_price!=0?(parseFloat(cap.item_quantity)*parseFloat(cap.item_offers_price)).toFixed(2):(parseFloat(cap?.item_quantity)*parseFloat(cap.item_selling_price)))
                totalTax+=(parseFloat(cap.item_offers_price!=0?(parseFloat(cap.item_quantity)*parseFloat(cap.item_offers_price)).toFixed(2):(parseFloat(cap?.item_quantity)*parseFloat(cap.item_selling_price)).toFixed(2))*(cap.item_tax/100))
            }})})
            setTotal(totalPrice.toFixed(2))
            setTax(totalTax.toFixed(2))
            setAmount(subTotal.toFixed(2))
            
            // Close cart if empty
            if (!userCart || userCart.length === 0 || userCart.every(p => !p.capacity || p.capacity.every(c => !c.item_quantity || c.item_quantity === 0))) {
                setCartOpen(false)
                setCartResponse(EMPTY_CART_RESPONSE)
            }
 },[cartResponse,userCart])
  
 // Build local order list with product details for rendering
 useEffect(()=>{
   if (!cartResponse) { setOrderList([]); return; }
   const merged = (userCart || []).map(prod => {
     const details = (cartResponse.product_details || []).find(d => d.id == prod.product_id);
     return { ...prod, product_details: details || {} };
   });
   setOrderList(merged);
 },[cartResponse,userCart]);

 // Cart actions (qty and clear)
 const updateQuantity = (productId, capacity, increment) => {
   let updatedCart = (userCart || []).map(item => {
     if (item.product_id === productId) {
       const updatedItem = { ...item };
       updatedItem.capacity = updatedItem.capacity.map(cap => {
         if (cap.item_capacity === capacity) {
           const updatedCap = { ...cap };
           if (increment) {
             updatedCap.item_quantity += 1;
           } else {
             updatedCap.item_quantity = Math.max(0, (updatedCap.item_quantity || 0) - 1);
           }
           return updatedCap;
         }
         return cap;
       });
       updatedItem.quantity = updatedItem.capacity.reduce((s, c) => s + (c.item_quantity || 0), 0);
       return updatedItem;
     }
     return item;
   }).filter(it => (it.quantity || 0) > 0);
   dispatch(updateUserCart(updatedCart));
 };

 const clearAllItems = (orderType) => {
   if (orderType) {
     // Clear only items of the specified type
     const remainingCart = (userCart || []).filter(item => {
       const origin = item.order_origin || 'walkin';
       return origin !== orderType;
     });
     dispatch(updateUserCart(remainingCart));
   } else {
     // Clear all items if no type specified
     dispatch(updateUserCart([]));
   }
 };
  
 useEffect(()=>{
    const hasItems = (userCart || []).some(product =>
      (product.capacity || []).some(cap => Number(cap.item_quantity) > 0)
    );

    if (!hasItems) {
      setCartOpen(false);
      setCartResponse(EMPTY_CART_RESPONSE);
      return;
    }

    createCart();
  },[userCart])
  useEffect(() => {
   kioskProductGet(productsType)
 },[productsType, resolvedHubId])

  const kioskProductGet = async (productsType)=>{
    if (!resolvedHubId) {
      console.warn("No hub resolved for kiosk product fetch");
      return;
    }
    if (productsType == 'online') {
      CustomAxios.post("kiosk_Products/", { hub: resolvedHubId }).then(res => {
        dispatch(updateKioskProduct(res.data.products))
      })}
      else {
       const hubId = resolvedHubId;
       CustomAxios.get(`products/category/walkin/${hubId}/`).then(res=>{
     const transformed = res.data.map(p => ({
       ...p,
       capacitydetails: p.capacitydetails.reduce((acc, item) => {
        const invId = resolvedHubId;
         if (!acc[invId]) acc[invId] = { capacities: [] };
         acc[invId].capacities.push({
           ...item,
           item_price: +item.item_price,
           item_tax: +item.item_tax,
           extraPercentage: +item.extraPercentage,
           item_offers_price: +item.item_offers_price,
           item_selling_price: +item.item_selling_price,
           item_special_offer: +item.item_special_offer,
           inventory_id: item.inventory
         });
         return acc;
       }, {})
     }));

     dispatch(updateKioskProduct(transformed))

    }).catch(error=>{
        console.error(error)
    })
    }
 }
 
// Auto-detect and set order type based on cart contents
useEffect(() => {
   const hasWalkin = (userCart || []).some(item => {
     const origin = item.order_origin || 'walkin';
     return origin === 'walkin';
   });
   const hasOnline = (userCart || []).some(item => item.order_origin === 'online');
   
   // Set default to the type that has items, or walkin if both/none
   if (hasWalkin && !hasOnline) {
     setSelectedOrderType('walkin');
   } else if (hasOnline && !hasWalkin) {
     setSelectedOrderType('online');
  }
  // If both types exist, keep current selection or default to walkin
  
  // Clear error when cart changes
  setOrderTypeError('');
}, [userCart]);

// Clear error when order type changes
useEffect(() => {
  setOrderTypeError('');
}, [selectedOrderType]);

const billingMachine = async (orderId,userId, payload) => {
  try {
    // Make the API call to generate the PDF
    const response = await CustomAxios.post("/place_bill_machine/", {
      user_id: userId,
      order_id: orderId,
      payload: payload,
    }, {
      responseType: "blob" // important! ensures Axios returns a Blob
    });

    // Convert the response to a Blob and create a URL
    const blob = new Blob([response.data], { type: "application/pdf" });
    const pdfUrl = URL.createObjectURL(blob);

    // Create a hidden iframe
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    // Wait for PDF to load and call print
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      // Optionally remove the iframe after printing
      setTimeout(() => document.body.removeChild(iframe), 15000);
    };
  } catch (error) {
    console.error(error);
    alert("Failed to generate PDF. Please try again.");
  }
};
const placeKioskOrder = async (payload) => {
  try {
    const res = await CustomAxios.post('kiosk_order_placement/', payload);  
    const result = res.data; // ← assign response to const

    if (result.message === "Successfully order created") {

      // Filter cart
      const remainingCart = (userCart || []).filter(item => {
        const origin = item.order_origin || 'walkin';
        return origin !== selectedOrderType;
      });

      // Call billing machine

      // Update Redux
      dispatch(updateUserCart(remainingCart));
      dispatch(updateorderRefresh(true));
    }
    return result;
  } catch (error) {
    console.error(error);
    alert("Failed to place order");
  }
};
// Place the order
const orderPlacement=async()=>{
    // Filter cart items by selected order type
    const filteredCart = (userCart || []).filter(item => {
      const origin = item.order_origin || 'walkin'; // default to walkin if not set
      return origin === selectedOrderType;
    });

    if (filteredCart.length === 0) {
      setOrderTypeError(`No ${selectedOrderType === 'walkin' ? 'walk-in' : 'online'} items in cart to place order.`);
      return;
    }
    
    // Clear error if validation passes
    setOrderTypeError('');

    // Calculate totals only for filtered items
    let filteredTotalPrice = 0;
    let filteredSubTotal = 0;
    let filteredTotalTax = 0;

    filteredCart.forEach(product => {
      product.capacity.forEach(cap => {
        if (cap.item_quantity > 0 && cap.item_quantity != "") {
          const basePrice = cap.item_offers_price != 0 
            ? parseFloat(cap.item_offers_price) 
            : parseFloat(cap.item_selling_price);
          const quantity = parseFloat(cap.item_quantity);
          const taxPercent = parseFloat(cap.item_tax) || 0;
          
          const itemSubTotal = parseFloat((quantity * basePrice).toFixed(2));
          const itemTax = parseFloat((itemSubTotal * taxPercent / 100).toFixed(2));
          const itemTotal = itemSubTotal + itemTax;

          filteredTotalPrice += itemTotal;
          filteredSubTotal += itemSubTotal;
          filteredTotalTax += itemTax;
        }
      });
    });
  // Sync the server cart to ONLY these filtered items before placing order
  try{
    if (!resolvedHubId) {
      console.warn("No hub resolved for order sync");
      return;
    }
    const syncPayload = {
      products: filteredCart,
      inventory_id: resolvedHubId,
      user: user
    };
    try {
      const syncResponse = await CustomAxios.post("kiosk_order_creation/", syncPayload);
      lastSyncedCart.current = JSON.stringify(syncPayload);
      // Update cart response with synced data
      if (syncResponse.data) {
        setCartResponse(syncResponse.data);
        // Preserve order_origin in synced cart
        const localById = filteredCart.reduce((acc, p) => { acc[p.product_id] = p; return acc; }, {});
        const mergedProducts = (syncResponse.data.cart?.products || []).map(p => {
          const origin = localById[p.product_id]?.order_origin;
          return origin ? { ...p, order_origin: origin } : p;
        });
        dispatch(updateUserCart(mergedProducts));
      }
    }catch(syncErr){
      console.error("Cart sync failed", syncErr);
      lastSyncedCart.current = null;
      // Continue with order placement even if sync fails, but log the error
      // The backend should handle the products array directly
    }
  } catch (syncErr) {
    console.error("Cart sync failed", syncErr);
    lastSyncedCart.current = null;
  }
    let payload={
        products: filteredCart, // Send only filtered items
        total_Amount: filteredTotalPrice.toFixed(2),
        amount: filteredSubTotal.toFixed(2),
        tax: filteredTotalTax.toFixed(2),
        user:user,
        inventory_id:resolvedHubId,
        deliveryMode:3,
        payment_mode: paymentMode,
        order_type: selectedOrderType
    }
    
    const result = await placeKioskOrder(payload);
    await billingMachine(result.order_id, result.user_id, payload);
    navigate('/home/order_management');
        }
        const handlePlaceholder = (val,placeholder)=>{

            if(!val){
              return <Typography sx={{color:"#64748B",fontSize:"14px",fontWeight:400}}>{placeholder}</Typography>
            }
            else {
              if (val=='cashfree'){
                return "Online Payment"
              }
              else if(val==="mayicash"){
                return "Mayi Cash"
              }
              else if(val==="cod"){
                return "Cash On Delivery"
        
              }
              else if(val==="cash"){
                return "Cash On Pickup"
              }
              else{
                return val
              }
            }
            
        
            
          }
    return  <Box
      sx={{
        width: "100%",
        height: "100%",
        minHeight: { xs: "70vh", md: "calc(100vh - 160px)" },
        background: "#fff",
        padding: { xs: "12px", sm: "16px", md: "24px" },
        display: "flex",
        flexDirection: "column",
        position: "relative"
      }}
    >

      <Box sx={{ display: "flex", alignItems: { xs: "flex-start", sm: "center" }, paddingBottom: { xs: "12px", md: "16px" }, gap: { xs: "8px", md: "16px" }, flexWrap: "wrap", flexDirection: { xs: "column", sm: "row" } }}>
        {user_role !== 'cashier' && (
          <Box sx={{ display: "flex", alignItems: "center", gap: { xs: "8px", md: "16px" }, width: { xs: "100%", sm: "auto" }, flexShrink: 0 }}>
            <Button 
              startIcon={<ArrowBackIosIcon />} 
              onClick={() => navigate('/home/order_management')}
              sx={{ textTransform: "none", minWidth: "auto", fontSize: { xs: "12px", md: "14px" } }}
            >
              Back
            </Button>
            <Typography sx={{ fontWeight: "600", fontSize: { xs: "16px", md: "20px" } }}>Create Order</Typography>
          </Box>
        )}
        <Box sx={{ 
          width: { xs: "100%", sm: "50%" }, 
          display: "flex", 
          justifyContent: "center", 
          flexShrink: 0
        }}>
          <InputBase 
            value={Filters.search} 
            startAdornment={<Search sx={{ color: "#9AA0A6", marginRight: "8px", fontSize: { xs: "18px", md: "24px" } }} />} 
            placeholder='Search products...' 
            onChange={(e) => { setFilters({ ...Filters, search: e.target.value }) }} 
            sx={{ 
              width: "100%",
              p: { xs: "8px 12px", md: "12px 16px" }, 
              border: "1px solid #dfe1e5", 
              borderRadius: "24px", 
              height: { xs: "36px", md: "44px" },
              fontSize: { xs: "14px", md: "16px" },
              background: "#fff",
              boxSizing: "border-box",
              minWidth: 0
            }} 
          />
        </Box>
      </Box>
      <TabContext value={productsType}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', display: "flex", alignItems: "center", gap: "8px" }}>
          {/* Hamburger Button - Only for walkin and mobile */}
          {productsType === 'walkin' && (
            <Button
              onClick={() => setSubcategorySidebarOpen(!subcategorySidebarOpen)}
              sx={{
                minWidth: "auto",
                padding: { xs: "8px", md: "10px" },
                color: "#6B7280",
                display: { xs: "block", md: "none" },
                "&:hover": {
                  background: "#F3F4F6"
                }
              }}
            >
              <Menu sx={{ fontSize: { xs: "20px", md: "24px" } }} />
            </Button>
          )}
          <TabList onChange={handleChange} aria-label="lab API tabs example" sx={{ flex: 1, "& .MuiTab-root": { fontSize: { xs: "12px", md: "14px" }, minHeight: { xs: "40px", md: "48px" }, padding: { xs: "8px 12px", md: "12px 16px" } } }}>
            <Tab label="Walkin Products" value="walkin" />
            <Tab label="Online products" value="online" />
          </TabList>
        </Box>
      </TabContext>
      
      {/* Overlay when sidebar is open on mobile */}
      {productsType === 'walkin' && subcategorySidebarOpen && (
        <Box
          onClick={() => setSubcategorySidebarOpen(false)}
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 1199,
            display: { xs: "block", md: "none" }
          }}
        />
      )}
      
      {/* Mobile Sidebar - Fixed overlay (only on mobile) */}
      {productsType === 'walkin' && (
        <Box sx={{
          position: "fixed",
          left: subcategorySidebarOpen ? 0 : "-100%",
          top: 0,
          bottom: 0,
          width: "280px",
          background: "#fff",
          borderRight: "1px solid #E2E8F0",
          zIndex: 1200,
          boxShadow: "2px 0 8px rgba(0,0,0,0.1)",
          display: { xs: "flex", md: "none" },
          flexDirection: "column",
          padding: "16px",
          overflowY: "auto",
          transition: "left 0.3s ease-in-out"
        }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Typography sx={{ fontSize: { xs: "16px", md: "18px" }, fontWeight: 600 }}>Subcategories</Typography>
            <Button
              onClick={() => setSubcategorySidebarOpen(false)}
              sx={{
                minWidth: "auto",
                padding: "4px",
                color: "#6B7280",
                display: { xs: "block", md: "none" },
                "&:hover": {
                  background: "#F3F4F6"
                }
              }}
            >
              <Close sx={{ fontSize: { xs: "20px", md: "24px" } }} />
            </Button>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <Button
              onClick={() => {
                setFilters({ ...Filters, subCategoryName: "" });
                setSubcategorySidebarOpen(false);
              }}
              sx={{
                textTransform: "none",
                justifyContent: "flex-start",
                fontSize: { xs: "13px", md: "14px" },
                color: !Filters.subCategoryName ? "#ED1E79" : "#6B7280",
                fontWeight: !Filters.subCategoryName ? 600 : 400,
                px: { xs: "12px", md: "16px" },
                py: { xs: "8px", md: "10px" },
                borderRadius: "8px",
                "&:hover": {
                  background: "#F3F4F6"
                }
              }}
            >
              All
            </Button>
            {walkinSubcategoriesList.length === 0 ? (
              <Typography sx={{ fontSize: "12px", color: "#6B7280", fontStyle: "italic", px: "16px" }}>
                No subcategories available
              </Typography>
            ) : (
              walkinSubcategoriesList.map(subcat => {
                const subcatName = subcat.subcategory_name || subcat.name || "Unknown";
                const isSelected = Filters.subCategoryName === subcatName;
                
                return (
                  <Button
                    key={subcat.id}
                    onClick={() => {
                      setFilters({ ...Filters, subCategoryName: subcatName });
                      setSubcategorySidebarOpen(false);
                    }}
                    sx={{
                      textTransform: "none",
                      justifyContent: "flex-start",
                      fontSize: { xs: "13px", md: "14px" },
                      color: isSelected ? "#ED1E79" : "#6B7280",
                      fontWeight: isSelected ? 600 : 400,
                      px: { xs: "12px", md: "16px" },
                      py: { xs: "8px", md: "10px" },
                      borderRadius: "8px",
                      "&:hover": {
                        background: "#F3F4F6"
                      }
                    }}
                  >
                    {subcatName}
                  </Button>
                );
              })
            )}
          </Box>
        </Box>
      )}
      
      <Box sx={{ display: "flex", gap: { xs: "8px", md: "16px" }, marginTop: { xs: "12px", md: "20px" }, flex: 1, minHeight: 0, flexDirection: { xs: "column", md: "row" } }}>
        {/* Subcategory Sidebar - Always visible on desktop */}
        {productsType === 'walkin' && (
          <Box sx={{
            width: { xs: 0, md: "200px" },
            flexShrink: 0,
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            background: "#fff",
            borderRight: "1px solid #E2E8F0",
            paddingRight: "16px",
            overflowY: "auto",
            maxHeight: "100%"
          }}>
            <Typography sx={{ fontSize: { xs: "12px", md: "14px" }, fontWeight: 600, mb: { xs: 1, md: 1.5 }, paddingTop: { xs: "8px", md: "8px" } }}>
              Subcategories
            </Typography>
            <Button
              onClick={() => {
                setFilters({ ...Filters, subCategoryName: "" });
                setSubcategorySidebarOpen(false);
              }}
              sx={{
                textTransform: "none",
                justifyContent: "flex-start",
                fontSize: { xs: "13px", md: "13px" },
                color: !Filters.subCategoryName ? "#ED1E79" : "#6B7280",
                fontWeight: !Filters.subCategoryName ? 600 : 400,
                px: { xs: "12px", md: "8px" },
                py: { xs: "8px", md: "6px" },
                borderRadius: "8px",
                mb: { xs: 0.5, md: 0.5 },
                "&:hover": {
                  background: "#F3F4F6"
                }
              }}
            >
              All
            </Button>
            {walkinSubcategoriesList.length === 0 ? (
              <Typography sx={{ fontSize: "12px", color: "#6B7280", fontStyle: "italic", px: "16px" }}>
                No subcategories available
              </Typography>
            ) : (
              walkinSubcategoriesList.map(subcat => {
                const subcatName = subcat.subcategory_name || subcat.name || "Unknown";
                const isSelected = Filters.subCategoryName === subcatName;
                
                return (
                  <Button
                    key={subcat.id}
                    onClick={() => {
                      setFilters({ ...Filters, subCategoryName: subcatName });
                      setSubcategorySidebarOpen(false);
                    }}
                    sx={{
                      textTransform: "none",
                      justifyContent: "flex-start",
                      fontSize: { xs: "13px", md: "13px" },
                      color: isSelected ? "#ED1E79" : "#6B7280",
                      fontWeight: isSelected ? 600 : 400,
                      px: { xs: "12px", md: "8px" },
                      py: { xs: "8px", md: "6px" },
                      borderRadius: "8px",
                      mb: { xs: 0.5, md: 0.5 },
                      "&:hover": {
                        background: "#F3F4F6"
                      }
                    }}
                  >
                    {subcatName}
                  </Button>
                );
              })
            )}
          </Box>
        )}
        
        {/* Center - Product List */}
        <Box sx={{ 
          flex: { xs: "1 1 100%", md: cartResponse && cartOpen ? "1 1 75%" : "1 1 100%" }, 
          display: "flex", 
          flexDirection: "column", 
          paddingBottom: { xs: cartResponse && cartOpen ? "80px" : "20px", md: "20px" },
          marginRight: { xs: 0, md: cartResponse && cartOpen ? "25%" : 0 },
          maxWidth: { xs: "100%", md: cartResponse && cartOpen ? "75%" : "100%" },
          width: { xs: "100%", md: "auto" }
        }}>
          <Grid 
            container 
            columns={24} 
            sx={{ 
              height: "600px",
              justifyContent:"flex-start",
              overflowY:"scroll", 
              alignItems: "flex-start",
              alignContent: "flex-start",
            }}
          >
            {(filtered.length>0?filtered: kiosk_products).map((item,ind)=>{
              return <ProductCard key={item.id || ind} item={item} productsType={productsType} />})}
          </Grid>
          
        </Box>

            

        {/* Floating Cart Button - Show when cart is closed */}
        {cartResponse && !cartOpen && (
          <Button
            onClick={() => setCartOpen(true)}
            disabled={userCart.reduce((sum, item) => sum + (item.quantity || 0), 0) === 0}
            sx={{
              position: "fixed",
              bottom: { xs: "16px", md: "24px" },
              right: { xs: "16px", md: "24px" },
              width: { xs: "56px", md: "64px" },
              height: { xs: "56px", md: "64px" },
              borderRadius: "50%",
              background: "#ED1E79",
              color: "#fff",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              zIndex: 1000,
              minWidth: "auto",
              "&:hover": {
                background: "#C2185B",
                boxShadow: "0 6px 16px rgba(0,0,0,0.2)"
              },
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <ShoppingCart sx={{ fontSize: { xs: "24px", md: "28px" } }} />
            <Box
              sx={{
                position: "absolute",
                top: { xs: "4px", md: "6px" },
                right: { xs: "4px", md: "6px" },
                background: userCart && userCart.length > 0 ? "#FF5722" : "#CBD5F5",
                color: "#fff",
                borderRadius: "50%",
                width: { xs: "20px", md: "22px" },
                height: { xs: "20px", md: "22px" },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: { xs: "10px", md: "11px" },
                fontWeight: 700
              }}
            >
              {userCart.reduce((sum, item) => sum + (item.quantity || 0), 0)}
            </Box>
          </Button>
        )}

        {/* Right side - Checkout Cart - Positioned outside the main container */}
        {cartResponse && cartOpen && (
          <Box sx={{ 
            position: { xs: "fixed", md: "absolute" }, 
            right: 0, 
            top: { xs: "auto", md: 0 }, 
            bottom: { xs: 0, md: 0 }, 
            left: { xs: 0, md: "auto" },
            width: { xs: "100%", md: "25%" }, 
            maxHeight: { xs: "60vh", md: "100%" },
            display: "flex", 
            flexDirection: "column", 
            borderLeft: { xs: "none", md: "1px solid #E2E8F0" },
            borderTop: { xs: "2px solid #E2E8F0", md: "none" },
            paddingLeft: { xs: "12px", md: "16px" }, 
            paddingRight: { xs: "12px", md: "24px" },
            paddingTop: { xs: "12px", md: "24px" },
            paddingBottom: { xs: "12px", md: "24px" },
            background: "#fff",
            height: { xs: "auto", md: "100%" },
            zIndex: { xs: 1000, md: 1 },
            boxShadow: { xs: "0 -4px 6px rgba(0,0,0,0.1)", md: "none" }
          }}>
            {/* Close Button */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: { xs: 1, md: 2 } }}>
              <Typography sx={{ fontSize: { xs: "16px", md: "18px" }, fontWeight: 600 }}>Cart</Typography>
              <Button
                onClick={() => setCartOpen(false)}
                sx={{
                  minWidth: "auto",
                  padding: { xs: "4px", md: "8px" },
                  color: "#6B7280",
                  "&:hover": {
                    background: "#F3F4F6"
                  }
                }}
              >
                <Close sx={{ fontSize: { xs: "20px", md: "24px" } }} />
              </Button>
            </Box>
            <Box sx={{overflowY:"auto",flex: 1, marginBottom: "16px", minHeight: 0}}>
              {/* Walk-in and Online sections */}
              {(() => {
                const calcPrice = (cap) => {
                  const base = cap.item_offers_price != 0 ? +cap.item_offers_price : +cap.item_selling_price;
                  const qty = +cap.item_quantity;
                  const taxP = +cap.item_tax || 0;
                  return (base * qty) * (1 + taxP / 100);
                };
                const calcOriginal = (cap) => {
                  const base = +cap.item_selling_price;
                  const qty = +cap.item_quantity;
                  const taxP = +cap.item_tax || 0;
                  return (base * qty) * (1 + taxP / 100);
                };
                const items = orderlist.flatMap(p => p.capacity
                  .filter(cap => (cap.item_quantity || 0) > 0)
                  .map(cap => ({ product: p, cap }))
                );
                const isOnline = (p) => (p.order_origin === 'online');
                const walkin = items.filter(x => x.product.order_origin !== 'online');
                const online = items.filter(x => isOnline(x.product));
                const Section = ({ title, data, orderType }) => data.length === 0 ? null : (
                  <Box sx={{ mb: { xs: 1.5, md: 2 } }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: { xs: "6px", md: "8px" }, borderBottom: "1px solid #E2E8F0", mb: { xs: 1, md: 1.5 } }}>
                      <Typography sx={{ fontWeight: 700, fontSize: { xs: "12px", md: "14px" } }}>{title}</Typography>
                      <Typography sx={{ color: "#0071BC", cursor: "pointer", fontSize: { xs: "11px", md: "12px" } }} onClick={() => clearAllItems(orderType)}>Clear items</Typography>
                    </Box>
                    {data.map(({ product, cap }, idx) => {
                      const details = product.product_details || {};
                      // Get original product from kiosk_products as fallback for images
                      const originalProduct = kiosk_products.find(p => p.id === product.product_id || p.id == product.product_id);
                      // choose image by origin, fallback gracefully
                      let imgSrc = "";
                      if (product.order_origin === 'online') {
                        imgSrc = (details.images && details.images[0]) 
                          || (originalProduct?.images && originalProduct.images[0])
                          || (details.image_urls && details.image_urls[0])
                          || "";
                      } else {
                        imgSrc = (details.image_urls && details.image_urls[0])
                          || (originalProduct?.image_urls && originalProduct.image_urls[0])
                          || (details.images && details.images[0])
                          || (originalProduct?.images && originalProduct.images[0])
                          || "";
                      }
                      const hasOffer = cap.item_offers_price != 0 && cap.item_offers_price != cap.item_selling_price;
                      return (
                        <Box key={`${product.product_id}-${cap.item_capacity}-${idx}`} sx={{ display: "flex", alignItems: "flex-start", padding: { xs: "8px 0", md: "10px 0" }, borderBottom: "1px solid #E2E8F0", gap: { xs: "8px", md: "10px" } }}>
                          <Box component="img" src={imgSrc || "/logo512.png"} onError={(e)=>{e.currentTarget.src="/logo512.png"}} sx={{ width: { xs: 45, md: 50 }, height: { xs: 45, md: 50 }, borderRadius: "6px", objectFit: "cover", background: "#F3F4F6", flexShrink: 0 }} />
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography sx={{ fontSize: { xs: "12px", md: "13px" }, fontWeight: 500, lineHeight: 1.3, mb: 0.5 }}>{details.item_name || originalProduct?.item_name || ""}</Typography>
                            <Typography sx={{ fontSize: { xs: "10px", md: "11px" }, color: "#6B7280" }}>{cap.item_capacity}</Typography>
                          </Box>
                          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: { xs: "4px", md: "6px" }, flexShrink: 0 }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: { xs: "3px", md: "4px" }, background: "#ED1E79", borderRadius: "16px", padding: { xs: "2px 4px", md: "2px 6px" } }}>
                              <Box onClick={() => updateQuantity(product.product_id, cap.item_capacity, false)} sx={{ display:"flex", alignItems:"center", justifyContent:"center", width:{ xs: 16, md: 18 }, height:{ xs: 16, md: 18 }, borderRadius:"50%", color:"#fff", cursor:"pointer" }}>
                                <RemoveIcon sx={{ fontSize: { xs: 11, md: 12 } }} />
                              </Box>
                              <Typography sx={{ fontSize: { xs: 11, md: 12 }, fontWeight: 600, minWidth: { xs: 14, md: 16 }, textAlign: "center", color: "#fff" }}>{cap.item_quantity}</Typography>
                              <Box onClick={() => updateQuantity(product.product_id, cap.item_capacity, true)} sx={{ display:"flex", alignItems:"center", justifyContent:"center", width:{ xs: 16, md: 18 }, height:{ xs: 16, md: 18 }, borderRadius:"50%", color:"#fff", cursor:"pointer" }}>
                                <AddIcon sx={{ fontSize: { xs: 11, md: 12 } }} />
                              </Box>
                            </Box>
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                              {hasOffer && <Typography sx={{ fontSize: { xs: "9px", md: "10px" }, color: "#9CA3AF", textDecoration: "line-through" }}>₹{calcOriginal(cap).toFixed(2)}</Typography>}
                              <Typography sx={{ fontSize: { xs: "12px", md: "13px" }, fontWeight: 700 }}>₹{calcPrice(cap).toFixed(2)}</Typography>
                            </Box>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                );
                return (
                  <Box>
                    <Section title="Review Items — Walk-in" data={walkin} orderType="walkin" />
                    <Section title="Review Items — Online" data={online} orderType="online" />
                  </Box>
                );
              })()}
            </Box>
            <Box sx={{ borderTop: "1px solid #E2E8F0", paddingTop: { xs: "8px", md: "12px" }, flexShrink: 0 }}>
              {/* Select Order Type - Hidden on mobile */}
              <Box sx={{ display: { xs: "none", md: "block" } }}>
                <FormLabel component="legend" sx={{ mb: { xs: 0.5, md: 0.75 }, fontSize: { xs: "11px", md: "13px" }, fontWeight: 600 }}>Select Order Type</FormLabel>
                <RadioGroup
                  row
                  value={selectedOrderType}
                  onChange={(e) => setSelectedOrderType(e.target.value)}
                  sx={{ mb: { xs: 1, md: 1.5 }, "& .MuiFormControlLabel-label": { fontSize: { xs: "11px", md: "12px" } } }}
                >
                  <FormControlLabel value="walkin" control={<Radio size="small" />} label="Walk-in" />
                  <FormControlLabel value="online" control={<Radio size="small" />} label="Online" />
                </RadioGroup>
                {orderTypeError && (
                  <Typography sx={{ 
                    fontSize: { xs: "10px", md: "11px" }, 
                    color: "#F5222D", 
                    mt: -1, 
                    mb: { xs: 0.5, md: 1 },
                    ml: 0.5
                  }}>
                    {orderTypeError}
                  </Typography>
                )}
              </Box>
              <FormLabel component="legend" sx={{ mb: { xs: 0.5, md: 0.75 }, fontSize: { xs: "11px", md: "13px" }, fontWeight: 600 }}>Select Payment Mode</FormLabel>
              <RadioGroup
                row
                value={paymentMode}
                onChange={(e) => setPaymentMode(e.target.value)}
                sx={{ mb: { xs: 1, md: 1.5 }, flexWrap: { xs: "wrap", md: "nowrap" }, "& .MuiFormControlLabel-label": { fontSize: { xs: "11px", md: "12px" } } }}
              >
                <FormControlLabel value="online" control={<Radio size="small" />} label="Online" />
                <FormControlLabel value="cash" control={<Radio size="small" />} label="Cash" />
                <FormControlLabel value="swiggy" control={<Radio size="small" />} label="Swiggy" />
                <FormControlLabel value="zomato" control={<Radio size="small" />} label="Zomato" />
              </RadioGroup>
              <Box sx={{display:"flex",alignItems:"center",justifyContent:"space-between", mt: { xs: 1, md: 1.5 }, flexDirection: { xs: "column", sm: "row" }, gap: { xs: "8px", sm: 0 }}}> 
                <Typography sx={{fontWeight:"700",fontSize:{ xs: "12px", md: "14px" }}}>Total: Rs.{total}</Typography>
                <Button variant="contained" sx={{textTransform:"none", fontSize: { xs: "11px", md: "12px" }, padding: { xs: "8px 20px", md: "6px 16px" }, width: { xs: "100%", sm: "auto" }}} onClick={orderPlacement}>Place Order</Button>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
                <useFetchOrders/>
    </Box>
    


} 

export default KioskOrderManagement